var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/js/product-information.js ***!
  \***************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ProductInformation = /*#__PURE__*/function () {
  function ProductInformation() {
    _classCallCheck(this, ProductInformation);
    // Observe if variant in document
    this.observeVariant();
  }
  _createClass(ProductInformation, [{
    key: "addSpansToRadioInputs",
    value: function addSpansToRadioInputs() {
      var radioInputs = document.querySelectorAll('.g-variant-color-detail input[type="radio"]');
      radioInputs.forEach(function (radioInput) {
        var dataValue = radioInput.value;
        var spanElement = document.createElement('span');
        spanElement.textContent = dataValue;
        spanElement.classList.add('color-value');
        radioInput.insertAdjacentElement('afterend', spanElement);
      });
    }
  }, {
    key: "moveSizeGuideLink",
    value: function moveSizeGuideLink() {
      var sizeGuideLink = document.querySelector('.guide-des-tailles-link');
      var dropdownSelector = document.querySelector('.product__info-container .product-form .dropdown-selector');
      if (sizeGuideLink && dropdownSelector) {
        dropdownSelector.appendChild(sizeGuideLink);
      }
    }
  }, {
    key: "showAdditionalElements",
    value: function showAdditionalElements() {
      var guideLink = document.querySelector('.guide-des-tailles-link');
      var swatchDetail = document.querySelector('.globo-swatch-product-detail');
      if (guideLink) {
        guideLink.style.display = 'block';
      }
      if (swatchDetail) {
        swatchDetail.style.display = 'block';
      }
    }
  }, {
    key: "removeGlobo",
    value: function removeGlobo() {
      var productPageClass = document.querySelector('.product-page');
      if (productPageClass.classList.contains('massage') || productPageClass.classList.contains('soin') || productPageClass.classList.contains('Expérience thermale') || productPageClass.classList.contains('Abonnement') || productPageClass.classList.contains('Forfait')) {
        document.querySelector('.globo-swatch-product-detail').remove();
      }
    }
  }, {
    key: "observeVariant",
    value: function observeVariant() {
      var _this = this;
      var observer = new MutationObserver(function (mutations) {
        var productDetail = document.querySelector('.globo-swatch-product-detail');
        var dropdownSelector = document.querySelector('.product__info-container .product-form .dropdown-selector');
        if (productDetail) {
          _this.removeGlobo();
        }
        if (dropdownSelector) {
          _this.moveSizeGuideLink();
          _this.addSpansToRadioInputs();
          _this.showAdditionalElements();
          observer.disconnect();
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }]);
  return ProductInformation;
}();
window.addEventListener('load', function () {
  new ProductInformation();
});
